import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';

export const DOCUMENT_RELATIONS_QUERY_KEY = 'document-relations';

export const useFetchFiles = (annotationId: number | null) => {
  const { data: documentRelations } = useQuery({
    queryKey: [DOCUMENT_RELATIONS_QUERY_KEY, annotationId] as const,
    queryFn: async () => {
      if (!annotationId)
        throw new Error(
          'Annotation id is required to fetch attachment relation'
        );

      const documentRelations = await api.unpaginatedRequest(
        endpoints.documentRelations.list
      )({ annotation: [annotationId] });

      return documentRelations;
    },
    enabled: !!annotationId,
    refetchInterval: 100_000,
  });
  return documentRelations;
};
